module.exports = __webpack_public_path__ + "images/sprites/tax_icons/tax_icon_category_ebook_reader_1a532a5d14842f0f22cb3efe8bd64c36.png";